require('./user-search.component.scss');

export class UserSearchController {
  constructor(
    $scope,
    $element,
    $timeout,
    $http,
    rx,
    observeOnScope,
    CurrentModelService,
    ErrorHandlerService,
    PermissionService
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$http = $http;
    this.rx = rx;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentModelService = CurrentModelService;
    this.filteredSuggestions = [];
    this.suggestionsAll = [];
    this.searchText = '';
    this.emails = '';
    this.admin = PermissionService.userMail ? {
      user_name: PermissionService.userName,
      mail: PermissionService.userMail
    } : null;

    this.subscriptions = [
      rx.Observable.merge(
        observeOnScope($scope, '$ctrl.searchText'),
      ).debounce(100)
      .do(() => {
        this.loading = true;
        this.suggestionsAll = [];
      })
      .switchMap(() => this.getSuggestions())
      .subscribe(
        (data) => {
          this.suggestionsAll = this.admin ? [this.admin, ...data.data.object_list] : data.data.object_list;
          this.loading = false;
          $scope.$digest();
        },
        (error) => {
          console.error(error);
          this.loading = false;
          $scope.$digest();
        },
      ),
      rx.Observable.merge(
        this.$scope.$eventToObservable('changeTab'),
        observeOnScope($scope, '$ctrl.emails'),
      )
      .debounce(50)
      .subscribe(() => {
        if (!this.emails) this.filterEmails = '';
        this.setTextHeight(0);
      })
    ];

    this.error = false;
  }

  $onInit() {
    this.setMails();
    // this.setTextHeight(2000);

  }

  setFilterEmails() {
    this.filterEmails = this.emails.replace(/[,;]+/ig, '\n')
      .split('\n')
      .map(m => {
        const r = m.trim().match(/.*@[\S]+/g);
        return r ? r[0] : '';
      })
      .filter(m => m)
      .join('\n').replace(/\(/g, '<').replace(/\)/g, '>');
    this.setMails();
  }

  setMails() {
    this.emails = this.filterEmails ? this.filterEmails.split('\n').map(m => m).join('; ')
      .replace(/\</g, '(').replace(/\>/g, ')') : '';
  }

  get suggestions() {
    return this.suggestionsAll;
  }

  isSelected(user) {
    return this.emails.indexOf(this.getUserMail(user)) != -1;
  }

  $onDestroy() {
    this.subscriptions.forEach((s) => {
      if (s.dispose) s.dispose();
    });
  }

  getUserName(user) {
    return `${user.full_name ? user.full_name : user.user_name}`;
  }

  getUserMail(user) {
    return `${user.full_name ? user.full_name : user.user_name}(${user.mail})`;
  }


  getSuggestions() {
    return this.rx.Observable.fromPromise(
      this.$http.get(`/analytics/users/?search=${this.searchText}`));
  }

  onSearchFocus() {
    // this.isOptionsOpen = true;
  }

  onSearchBlur() {
    // this.isOptionsOpen = false;
  }

  onSearchEnter(e) {
    if (e && e.keyCode != 13) return;
    this.selectUser(this.searchText);
    this.searchText = '';
  }

  cleanSearch() {
    this.searchText = '';
  }

  selectUser(user) {
    if (this.disabled) return;
    const email = this.getUserMail(user);

    if (this.emails) {
      if (!this.isSelected(user)) this.emails = `${email}; ${this.emails}`;
      else {
        const r = new RegExp(`${email.replace('(', '\\(').replace(')', '\\)')}[\s\,\.;,\n]*`, 'i');
        this.emails = this.emails.replace(r, '');
      }
    } else this.emails = email;

    this.setFilterEmails();
  }

  setTextHeight(time) {
    this.$timeout(() => {
      // this.$scope.$root.$apply();
      const el = this.$element.find('.selected-mails textarea');

      if (!el[0]) return;
      el.height(26);
      if (el[0].scrollHeight !== el[0].clientHeight) {
        const scrH = el[0].scrollHeight;
        el.height(scrH);
        this.$scope.$root.$digest();
      }
    }, time);
  }

  get hasSuggestions() {
    return this.suggestions.length > 0;
  }
}

export const UserSearchComponent = {
  bindings: {
    filterEmails: '=',
    disabled: '@',
  },
  template: require('./user-search.component.html'),
  controller: UserSearchController,
};



// WEBPACK FOOTER //
// ./src/filter/editor/user-search/user-search.component.js